import {
  CustomDataGrid,
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useEquipment } from "@services/servicesGenericsTables";
import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FooterTable } from "./footerTableVolumen";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

interface RowData {
  id: number;
  volumen_agua_muestra_acumulada: any;
  volumen_aire_muestreado_muestra: number;
  total_aire_muestreado: number;
  [key: string]: any;
}

const VolumeData = () => {
  const { currentPreparation, filterCurrentPreparation } = useAnalysis();
  const form = useFormContext();
  const { setValue } = useFormContext();
  const [columns, setColumns] = useState([]);
  const { equipmentList } = useEquipment();

  const sampleCountVapor = useWatch({
    name: "sampleCountVapor",
    control: form.control,
  });

  const totalSampleWaterVolume = useWatch({
    name: "totalSampleWaterVolume",
    control: form.control,
  });

  const rows = useWatch({
    name: "rowsVolumeData",
    control: form.control,
    defaultValue: [],
  });

  const indexCurrentPreparation = currentPreparation.index;

  let volumeRegistriesData;
  //let totalSampleWaterVolume = 0;
  const preparationsList = filterCurrentPreparation();
  if (
    indexCurrentPreparation !== undefined &&
    preparationsList &&
    indexCurrentPreparation < preparationsList.length
  ) {
    //totalSampleWaterVolume = preparationsList[indexCurrentPreparation]["total_sample_water_volume"]||0;
    volumeRegistriesData =
      preparationsList[indexCurrentPreparation]["volumeRegistries"] || [];
  }

  useEffect(() => {
    if (rows.length === 0) {
      const initialRows: any = [
        {
          id: 1,
          volumen_agua_muestra_acumulada: "Volumen total aire por muestra (m³)",
          volumen_aire_muestreado_muestra: 0,
          total_aire_muestreado: null,
        },
      ];

      if (volumeRegistriesData.length > 0) {
        volumeRegistriesData.forEach((registry, i) => {
          initialRows[0][`muestra_${i + 1}`] =
            registry.value_volume_tritio_air || 0;
        });
      }
      initialRows.forEach((updatedRow: RowData) => {
        processRowUpdate(updatedRow);
      });

      setValue("rowsVolumeData", initialRows);
    } else {
      const updatedRows: any = rows.map((row: any, index: any) => {
        if (index === 0) {
          let totalAireMuestreado = 0;

          for (let i = 1; i <= sampleCountVapor; i++) {
            const volumenAire = parseFloat(row[`muestra_${i}`]) || 0;
            totalAireMuestreado += volumenAire;
          }
          return {
            ...row,
            total_aire_muestreado: totalAireMuestreado,
          };
        }
        return row;
      });

      if (volumeRegistriesData.length > 0) {
        volumeRegistriesData.forEach((registry, i) => {
          updatedRows[`muestra_${i + 1}`] =
            registry.value_volume_tritio_air || 0;
        });
      }

      updatedRows.forEach((updatedRow: RowData) => {
        processRowUpdate(updatedRow);
      });

      setValue("rowsVolumeData", updatedRows);
    }
  }, [sampleCountVapor, totalSampleWaterVolume]);

  useEffect(() => {
    const dynamicColumns: any = [
      {
        field: "volumen_agua_muestra_acumulada",
        headerName: "Trito en Aire - datos de volúmenes",
        editable: false,
        flex: 1,
      },
    ];

    for (let i = 1; i <= sampleCountVapor; i++) {
      dynamicColumns.push({
        field: `muestra_${i}`,
        headerName: `Muestra ${i}`,
        editable: true,
        flex: 1,
      });
    }

    dynamicColumns.push({
      field: "total_aire_muestreado",
      headerName: "Totales",
      editable: false,
      flex: 1,
    });

    setColumns(dynamicColumns);
  }, [sampleCountVapor]);

  useEffect(() => {
    const totalAireMuestreado = rows.reduce(
      (acc: any, row: any) => acc + (row.total_aire_muestreado || 0),
      0
    );

    setValue("sampledAirVolume", totalAireMuestreado);
  }, [rows, setValue]);

  const processRowUpdate = (newRow: RowData) => {
    if (newRow.id === 1) {
      let totalAireMuestreado = 0;
      const dataVolumeRegistries: number[] = [];
      for (let i = 1; i <= sampleCountVapor; i++) {
        const value = newRow[`muestra_${i}`];
        const valueAsNumber = Number(value);
        const isValidNumber =
          !isNaN(valueAsNumber) && typeof valueAsNumber === "number";

        if (!isValidNumber) {
          newRow[`muestra_${i}`] = "";
          continue;
        }
        const volumenAire = parseFloat(value) || 0;

        //const volumenAire = parseFloat(newRow[`muestra_${i}`]) || 0;
        totalAireMuestreado += volumenAire;
        dataVolumeRegistries.push(volumenAire);
      }
      newRow.total_aire_muestreado = totalAireMuestreado;

      const updatedRows = rows.map((row: any) => {
        if (row.id === 1) {
          return {
            ...newRow,
            total_aire_muestreado: totalAireMuestreado,
          };
        }
        return row;
      });

      setValue("dataVolumeRegistries", dataVolumeRegistries);
      setValue("rowsVolumeData", updatedRows);
    }
    return newRow;
  };
  //dataVolumeRegistries

  return (
    <>
      <ResponsiveFormContainer columns={5} mt={2}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("analysis_equipment"))}
          name="analysis_equipment"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MTextField
          name="totalSampleWaterVolume"
          label="Volumen total de agua de la muestra acumulada (ml)"
          placeholder="Volumen total de agua de la muestra acumulada (ml)"
          type="number"
          fullWidth
          validation={{
            required:
              "El volumen total de agua de la muestra acumulada (ml) es requerido",
          }}
        />

        <MTextField
          name="sampleCountVapor"
          label="Número de muestras"
          placeholder="Número de muestras"
          type="number"
          fullWidth
          inputProps={{ min: 0 }}
          validation={{
            required: "El número de muestras es requerido",
            min: {
              value: 0,
              message: "El número de muestras debe ser igual o mayor a cero",
            },
          }}
        />

        <MTextField
          name="sampledAirVolume"
          label="Volumen de aire muestreado (m³)"
          placeholder="Volumen de aire muestreado (m³)"
          type="number"
          fullWidth
          disabled
        />
      </ResponsiveFormContainer>
      <CustomDataGrid
        rows={rows}
        columns={columns}
        search={false}
        processRowUpdate={processRowUpdate}
        disablePagination={true}
        key={`volumen_data-${currentPreparation?.index}-${currentPreparation?.id}`}
      />
      <FooterTable
        columns={columns}
        rows={rows}
        totalSampleWaterVolume={totalSampleWaterVolume}
      />
    </>
  );
};

export default VolumeData;
